// extracted by mini-css-extract-plugin
export default {"wrapper":"descriptionform_wrapper__Q3t9J","destination":"descriptionform_destination__NW+2J","inputWrapper":"descriptionform_inputWrapper__v4emR"};